<template>
  <div class="phone-top-nav" :class="{ hideBar }" @click="hideBar = false">
    <div class="top-nav top-nav-left">
      <svg class="icon-svg return" @click="returnHome()">
        <use xlink:href="#icon-return" />
      </svg>
    </div>
    <div class="top-nav top-nav-right">
      <svg class="icon-svg" style="padding-top: 3px;" @click="readSettingVisible = true" v-if="fromType == 'yuanxi'">
        <use xlink:href="#icon-book" />
      </svg>
      <svg class="icon-svg" @click="chooseBar('show_npc')" v-if="fromType == 'yuanxi'">
        <use xlink:href="#icon-ai" />
      </svg>
      <svg class="icon-svg icon-badge" @click="chooseBar('show_achievement')">
        <use xlink:href="#icon-badge" />
      </svg>
    </div>

    <chat-npc :roleKeyword="roleKeyword" :phoneMode="true" v-if="bar.show_npc"></chat-npc>
    <achievementBox :phoneMode="true" @closeBox="bar.show_achievement = false" v-if="bar.show_achievement">
    </achievementBox>

    <a-modal v-model:visible="readSettingVisible" title="阅读设置" :footer="null">
      <ReadSetting @close="readSettingVisible = false" />
    </a-modal>
  </div>
</template>

<script>

import achievementBox from "@/components/achievement/achievement-box/achievement-box.vue";
import chatNpc from "@/components/chat-npc/chat-npc.vue";
import ReadSetting from "@/components/read-setting/read-setting.vue";

export default {
  name: "phoneTopNav",
  components: {
     achievementBox, chatNpc, ReadSetting
  },
  data() {
    return {
      fromType: '',
      returnUrl: '',
      roleKeyword: '',
      readSettingVisible: false,
    }
  },
  props: {
    returnNav: String,
    hideBar: Boolean,
    bar: Object
  },
  async mounted() {
    let { fromType, returnUrl, currentClass } = this.$store.state;
    this.fromType = fromType;
    this.returnUrl = returnUrl;

    if (currentClass) this.roleKeyword = currentClass.ClassName.replace('教材', '').replace('演示', '');
  },
  methods: {
    //跳转首页
    returnHome() {
      if (this.returnUrl) return window.location.href = this.returnUrl;
      else window.location.href = 'https://yuanxi.online';
    },
    //打开code
    openCode(code) {
      this.chooseBar('show_nav');
      this.$emit('openCode', code);
    },
    //打开code
    switchChapter(id) {
      this.chooseBar('show_nav');
      this.$emit('switchChapter', id);
    },
    //选择底部
    chooseBar(type) {
      let bar = this.bar;
      if (bar[type]) return bar[type] = false;

      for (const key in bar) { bar[key] = false }
      bar[type] = true;
    }
  }
}
</script>

<style scoped lang="scss">
@import "./phone-top-nav.scss";
</style>